import { render, staticRenderFns } from "./SavedSearchStandaloneApp.vue?vue&type=template&id=2632a408"
import script from "./SavedSearchStandaloneApp.vue?vue&type=script&lang=js"
export * from "./SavedSearchStandaloneApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports